import { createSelector } from 'reselect'
const getPassengerCounts = (state) => state.landingPage.passengers
const getPreferredCabin = (state) => state.landingPage.preferredCabin  
// const getPassengers = (state) => state.landingPage.passengers  



const getTotalNumberOfPassengers = createSelector(
  [ getPassengerCounts ],
  (passengerCounts) => {
    var totalNumberOfPassengers = 0
    for (var k in passengerCounts) {
      totalNumberOfPassengers += passengerCounts[k]
    }
    return totalNumberOfPassengers 
  }
)
const getTotalNumberOfAdults = createSelector(
  [ getPassengerCounts ],
  (passengerCounts) => {
    return passengerCounts['adultCount'] + passengerCounts['seniorCount'] 
  }
)
const getTotalNumberOfChildren = createSelector(
  [ getPassengerCounts ],
  (passengerCounts) => {
    return passengerCounts['childCount'] + passengerCounts['infantInLapCount'] + passengerCounts['infantInSeatCount'] 
  }
)
const getInfantInLapCount = createSelector(
  [ getPassengerCounts ],
  (passengerCounts) => {
    return passengerCounts['infantInLapCount'] 
  }
)
const isAdultAccompanyingChildren = createSelector(
  [ getTotalNumberOfChildren, getTotalNumberOfAdults ],
  (totalNumberOfChildren, totalNumberOfAdults) => {
    return totalNumberOfChildren > 0 ? totalNumberOfAdults > 0 : true
  }
)

export const getModalContentValidity = createSelector(
  [ getTotalNumberOfPassengers, isAdultAccompanyingChildren, getInfantInLapCount, getTotalNumberOfAdults ],
  (totalNumberOfPassengers, isAdultAccompanyingChildren, infantInLapCount, totalNumberOfAdults) => {
    var errorMessage 
    if (totalNumberOfPassengers > 8) {
      errorMessage = `You cannot select more than 8 passengers`
    } else if (totalNumberOfPassengers < 1) {
      errorMessage = `At least one passenger must be selected`
    } else if (!isAdultAccompanyingChildren) {
      errorMessage = `At least one adult or senior passenger must be selected`
    } else if (infantInLapCount > totalNumberOfAdults) {
      errorMessage = `The number of infants in lap cannot be more than the number of adults + seniors`
    }

    const modalContentValidity = {
      isModalContentValid: !errorMessage,
      errorMessage: errorMessage
    }
    return modalContentValidity
  }
)


export const getCabinPassengerFieldMessage = createSelector(
  [ getTotalNumberOfPassengers, getPreferredCabin ],
  (totalNumberOfPassengers, preferredCabin) => {
    return (
      totalNumberOfPassengers === 1
      ? `1 traveler, ${preferredCabin}`
      : `${totalNumberOfPassengers} travelers, ${preferredCabin}`
    )
  }
)



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/PassengerCabinField/selectors.js